import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, take } from "rxjs";
import environment from '../../environments/environment';
import {
  ApiResponse,
  ArrayApiResponse,
  CreateUpdateTech,
  Ecosystem,
  Tag,
  TagGenre,
  Tech,
  TechDetail
} from '../models/models';
const { url } = environment
console.log(environment)
@Injectable()
export class TechService {
  private http = inject(HttpClient);


  //Get multiples

  getTechs(): Observable<ArrayApiResponse<Tech>> {
    return this.http.get<ArrayApiResponse<Tech>>(`${url}/techs`);
  }
  getTechsSearch(name: string): Observable<ArrayApiResponse<Tech>> {
    return this.http.get<ArrayApiResponse<Tech>>(`${url}/techs/search/${name}`);
  }

  getTechsInbox(): Observable<ArrayApiResponse<Tech>> {
    return this.http.get<ArrayApiResponse<Tech>>(`${url}/techs/inbox`);
  }

  getEcosystems(): Observable<ArrayApiResponse<Ecosystem>> {
    return this.http.get<ArrayApiResponse<Ecosystem>>(`${url}/ecosystems`);
  }

  getTags(): Observable<ArrayApiResponse<Tag>> {
    return this.http.get<ArrayApiResponse<Tag>>(`${url}/tags`);
  }

  getTagsWithDetail(): Observable<ArrayApiResponse<Tag>> {
    return this.http.get<ArrayApiResponse<Tag>>(`${url}/tags/detail`);
  }

  getTagGenres(): Observable<ArrayApiResponse<TagGenre>> {
    return this.http.get<ArrayApiResponse<TagGenre>>(`${url}/tagGenres`);
  }
  getTechsByTag(tagId: string): Observable<ArrayApiResponse<Tech>> {
    return this.http.get<ArrayApiResponse<Tech>>(`${url}/techs/tag/${tagId}`);
  }
  getTechsDetails(): Observable<ArrayApiResponse<TechDetail>> {
    return this.http.get<ArrayApiResponse<TechDetail>>(`${url}/techs/detail/complete`);
  }

  getTechDetailBySlug(slug: string): Observable<ApiResponse<TechDetail>> {
    return this.http.get<ApiResponse<TechDetail>>(`${url}/tech/detail/${slug}`);
  }

  getTagById(id: string): Observable<ApiResponse<Tag>> {
    return this.http.get<ApiResponse<Tag>>(`${url}/tag/${id}`);
  }

  getTagWithDetailById(id: string): Observable<ApiResponse<Tag>> {
    return this.http.get<ApiResponse<Tag>>(`${url}/tag/detail/${id}`);
  }

  getEcosystemById(id: string): Observable<ApiResponse<Ecosystem>> {
    return this.http.get<ApiResponse<Ecosystem>>(`${url}/ecosystem/${id}`);
  }

  getTagGenreById(id: string): Observable<ApiResponse<TagGenre>> {
    return this.http.get<ApiResponse<TagGenre>>(`${url}/tagGenre/${id}`);
  }

  //Post

  postTech(tech: CreateUpdateTech): Observable<ApiResponse<TechDetail>> {
    return this.http.post<ApiResponse<TechDetail>>(`${url}/tech`, tech);
  }

  postEcosystem(ecoSystem: Ecosystem): Observable<ApiResponse<Ecosystem>> {
    return this.http.post<ApiResponse<Ecosystem>>(
      `${url}/ecosystem`,
      ecoSystem
    );
  }

  postTag(tag: Pick<Tag, "name">): Observable<ApiResponse<Tag>> {
    return this.http.post<ApiResponse<Tag>>(`${url}/tag`, tag);
  }

  postTagGenre(tagGenre: Omit<TagGenre, "id">): Observable<ApiResponse<TagGenre>> {
    return this.http.post<ApiResponse<TagGenre>>(`${url}/tagGenre`, tagGenre);
  }

  //Put
  putTech(id: string, tech: CreateUpdateTech): Observable<ApiResponse<TechDetail>> {
    return this.http.put<ApiResponse<TechDetail>>(`${url}/tech/${id}`, tech);
  }

  putEcosystem(
    id: string,
    ecoSystem: Ecosystem
  ): Observable<ApiResponse<Ecosystem>> {
    return this.http.put<ApiResponse<Ecosystem>>('/ecosystem/' + id, ecoSystem);
  }

  putTag(id: string, tag: Tag): Observable<ApiResponse<Tag>> {
    return this.http.put<ApiResponse<Tag>>(`${url}/tag/${id}`, tag);
  }

  putTagGenre(id: string, tagGenre: TagGenre): Observable<ApiResponse<TagGenre>> {
    return this.http.put<ApiResponse<TagGenre>>(`${url}/tagGenre/${id}`, tagGenre);
  }

  putEcosystemOnTech(techid: string, ecosystemId: string) {
    return this.http.put(
      `${url}/tech/` + techid + '/ecosystems/' + ecosystemId,
      null
    ).pipe(take(1));
  }

  putTagsOnTech(techid: string, tagId: string) {
    return this.http.put(`${url}/tech/` + techid + '/tags/' + tagId, null).pipe(take(1));
  }

  // Delete
  deleteTech(id: string) {
    return this.http.delete(`${url}/tech/${id}`);
  }

  deleteEcosystemFromTech(id: string, ecosystemId: string) {
    return this.http.delete(`${url}/tech/${id}/ecosystems/${ecosystemId}`).pipe(take(1));
  }

  deleteTagFromTech(techid: string, tagId: string) {
    return this.http.delete(`${url}/tech/${techid}/tags/${tagId}`).pipe(take(1));
  }

  deleteEcosystem(id: string) {
    return this.http.delete(`${url}/ecosystem/${id}`);
  }

  deleteTag(id: string) {
    return this.http.delete(`${url}/tag/${id}`);
  }

  deleteTagGenre(id: string) {
    return this.http.delete(`${url}/tagGenre/${id}`);
  }

  // Archive
  archiveTech(id: string) {
    return this.http.put(`${url}/tech/${id}/archive`, null).pipe(take(1));
  }
}
